'use client';

import type { ReactElement } from 'react';
import { useState } from 'react';
import { SessionData } from '@auth0/nextjs-auth0/types';
import { useAppSelector } from 'lib/hooks';
import { selectSavedPlansCount } from 'slices/selectors';
import BookmarkIcon from 'components/icons/BookmarkIcon';
import UIButton from 'components/buttons/UIButton';

interface SavedPlansButtonProps {
  session: null | SessionData;
}

export default function SavedPlansButton({
  session,
}: SavedPlansButtonProps): ReactElement | null {
  const savedPlansCount = useAppSelector(selectSavedPlansCount);
  const [prevSavedPlansCount, setPrevSavedPlansCount] =
    useState(savedPlansCount);
  const [isBouncing, setIsBouncing] = useState(false);

  if (!session) {
    return null;
  }

  if (savedPlansCount !== prevSavedPlansCount) {
    if (savedPlansCount > prevSavedPlansCount) {
      setIsBouncing(true);
    }
    setPrevSavedPlansCount(savedPlansCount);
  }

  return (
    <UIButton
      buttonType="text"
      className="saved-plans-btn"
      href="/saved-plans"
      label="Saved Plans"
      iconPosition="left"
      icon={
        <BookmarkIcon
          className={isBouncing ? 'bounce' : undefined}
          onAnimationEnd={() => setIsBouncing(false)}
          isSaved={savedPlansCount > 0}
        />
      }
    />
  );
}
